<template>    
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'股权融资管理'},{name:'基金合作申请列表',goback:true},{name:'基金合作申请详情'}]" :title="'基金合作申请详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="提交信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                     <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{checkInfo.applicant}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{checkInfo.contactPhone}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{checkInfo.applyCompany}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{checkInfo.applyRemark}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in checkInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{checkInfo.createTime}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
             
              <el-card class="basic box_card mt16" header="操作记录" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">操作账号：</div>
                            <div class="content">{{checkInfo.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">操作时间：</div>
                            <div class="content">{{checkInfo.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{checkInfo.checkExplanation}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            checkInfo:{
                applicant:"",//申请人姓名：
                contactPhone:"",//联系手机号：
                applyCompany:"",//公司全称：
                applyRemark:"",//说明：
                fileList:[],//附件
                createTime:"",//提交时间：
                modifyUserName:"",//申请人姓名：
                updateTime:"",//操作时间：
                checkExplanation:"",//说明：
            }
        }
    },
    methods:{
        open(){
          this.$alert('点击附件')
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/fund/apply/details/'+this.id)
          if (code == 200) {            
              this.checkInfo=data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height: 100%;
  overflow: hidden;
}
.box{
  height:calc(100% - 40px);
  overflow-x: hidden;
  overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>